import { ArrowRight } from 'lucide-react'
import { Badge } from '@/shared/components/ui/badge'
import { Button } from '@/shared/components/ui/button'
import type { AICapability } from '../types/ai-assistant.types'

interface AICapabilityCardProps {
  capability: AICapability
  onClick: () => void
}

export function AICapabilityCard({
  capability,
  onClick,
}: AICapabilityCardProps) {
  return (
    <Button
      variant='outline'
      className='w-full h-auto p-0 text-left hover:shadow-lg transition-all duration-200 hover:border-blue-300'
      onClick={onClick}
    >
      <div className='p-4 space-y-3 w-full'>
        {/* Header */}
        <div className='flex items-start justify-between'>
          <div className='flex-1 min-w-0'>
            <h4 className='font-semibold text-sm'>{capability.title}</h4>
            <Badge variant='outline' className='text-xs mt-1'>
              {capability.category}
            </Badge>
          </div>
          <ArrowRight className='h-4 w-4 text-muted-foreground mt-1 flex-shrink-0' />
        </div>

        {/* Description */}
        <p className='text-xs text-muted-foreground leading-relaxed line-clamp-2'>
          {capability.description}
        </p>

        {/* Quick Preview of Examples */}
        <div className='space-y-1'>
          {capability.examples.slice(0, 2).map((example, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton
            <div key={index} className='flex items-start gap-2'>
              <div className='w-1 h-1 bg-blue-400 rounded-full flex-shrink-0 mt-1.5' />
              <span className='text-xs text-muted-foreground line-clamp-1'>
                {example}
              </span>
            </div>
          ))}
          {capability.examples.length > 2 && (
            <div className='text-xs text-blue-600'>
              +{capability.examples.length - 2} more capabilities
            </div>
          )}
        </div>
      </div>
    </Button>
  )
}
